import {
  Button,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  MenuProps,
  withStyles,
} from "@material-ui/core";
import { MenuTwoTone } from "@material-ui/icons";
import React from "react";
import { useNavigate } from "react-router-dom";
import HomeIcon from "@material-ui/icons/Home";
import InfoIcon from "@material-ui/icons/Info";
import ShowChartIcon from "@material-ui/icons/ShowChart";
import MultilineChartIcon from "@material-ui/icons/MultilineChart";

const StyledMenu = withStyles({
  paper: {
    border: "1px solid #d3d4d5",
  },
})((props: MenuProps) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    "&:focus": {
      backgroundColor: theme.palette.primary.main,
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);

const MobileMenu = () => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        aria-controls="customized-menu"
        aria-haspopup="true"
        variant="contained"
        color="primary"
        onClick={handleClick}
      >
        <MenuTwoTone />
      </Button>
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <StyledMenuItem
          onClick={() => {
            navigate("/Inicio");
          }}
        >
          <ListItemIcon>
            <HomeIcon />{" "}
          </ListItemIcon>
          <ListItemText primary="Inicio" />
        </StyledMenuItem>
        <StyledMenuItem
          onClick={() => {
            window.open("https://www.te.gob.mx/estadisticas/");
          }}
        >
          <ListItemIcon>
            <ShowChartIcon />{" "}
          </ListItemIcon>
          <ListItemText primary="Estadística judicial" />
        </StyledMenuItem>
        <StyledMenuItem
          onClick={() => {
            navigate("/Reporteador");
          }}
        >
          <ListItemIcon>
            <MultilineChartIcon />
          </ListItemIcon>
          <ListItemText primary="Portal de estadística interactivo" />
        </StyledMenuItem>
      </StyledMenu>
    </div>
  );
};

export default MobileMenu;
